<template>
  <div class="-contextmenu" v-if="value" @contextmenu="noop" @scroll="noop" @wheel="noop" @click="closeContextMenu">
    <div class="-contextmenu-list" :style="{ top: `${top}px`, left: `${left}px` }">
      <div v-for="(v, i) in menu" :key="i" class="-contextmenu-item" @click.stop="callback(v)">{{ v.title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContextMenu',
  props: {
    menu: Array,
    value: Boolean,
    left: Number,
    top: Number,
    callback: Function,
  },
  methods: {
    noop (e) {
      e.preventDefault()
      e.stopPropagation()

      return false
    },
    closeContextMenu () {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="scss">
.-contextmenu {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  user-select: none;
  z-index: 101;

  .-contextmenu-list {
    position: absolute;
    width: auto;
    height: auto;
    padding: 2px 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #f0f0f0;
    border-radius: 4px;
  }

  .-contextmenu-item {
    font-size: 14px;
    padding: 2px 16px;
    cursor: pointer;

    &:hover {
      background-color: #ed6c00;
      color: #ffffff;
    }
  }
}
</style>
